export { default as on } from './on';
export { default as onDocumentReady } from './onDocumentReady';

export const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion)').matches;

export function isMobile() {
  return window.innerWidth < 1070;
}